import { render, staticRenderFns } from "./csv-import-sales-purchase-price.vue?vue&type=template&id=610b91fe&"
import script from "./csv-import-sales-purchase-price.vue?vue&type=script&lang=js&"
export * from "./csv-import-sales-purchase-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports